import STPersonNotifications from "../st-person-notifications/st-person-notifications";

export default function STBannerNotifications() {
    return <STPersonNotifications displayType="banner" />;
}

STBannerNotifications.defaultProps = {};
